export default __webpack_public_path__ + "static/media/valve.f148dc7e.png";